import { useEffect, useState } from 'react';

/** Dotykove zarizeni bez mysi (tablet, telefon). iPad s pripojenou mysi/trackpadem sem nespada. */
const TOUCH_QUERY = '(hover: none) and (pointer: coarse)';

/**
 * True na dotykovem zarizeni bez mysi. Sirka okna tu nestaci — iPad na sirku ma 1024–1366 px,
 * tedy „desktopovou“ sirku, ale hover (zasouvani menu najetim mysi) tam nefunguje.
 */
export function useIsTouchDevice() {
  const [isTouch, setIsTouch] = useState(() => window.matchMedia(TOUCH_QUERY).matches);

  useEffect(() => {
    const media = window.matchMedia(TOUCH_QUERY);
    const listener = (event: MediaQueryListEvent) => setIsTouch(event.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, []);

  return isTouch;
}
